import React, { useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { Eye, Eyeselect, Dropdown } from './svg'
import CheckCircle from '@mui/icons-material/CheckCircle'
import { urls } from './constants'
import { useEffect } from 'react'

const LineInputV3 = React.memo((props) => {
  const { id, name, autoFocus, crossIconId, onFocus, onBlur, onKeyPress, onKeyDown, onClick, placeholder } = props
  const { value, filter, upperCase, maxLength=100, disabled, resetCallback, label, icon, type,sx } = props
  const [isFocus, setIsFocus] = useState(false)
  const [isBlur, setIsBlur] = useState(true)
  const [stateValue, setStateValue] = useState(value)
  const [hidepwd, setHidePwd] = useState(true)
  const ref = useRef(null)

  useEffect(() => {
    setStateValue(value);
  }, [value]);
  
  const showIcon = () => {
    if (hidepwd) {
      return <Eyeselect />
    } else {
      return <Eye />
    }
  }

  const togglePwd = () => {
    ref.current.type = ref.current.type === 'password' ? 'text' : 'password'
    setHidePwd(!hidepwd)
  }

  const handleChange = (e) => {
    let val = e.target.value
    if (filter) val = filter(val)
    if (upperCase && typeof val === 'string') val = val.toUpperCase()
    if ((val + '').length <= maxLength && !disabled) {
      setStateValue(val)
    }
  }

  const resetItem = () => {
    resetCallback && resetCallback()
    setStateValue('')
  }

  const handleFocus = (e) => {
    if (disabled) {
      e.key = 'Enter'
      onKeyDown && onKeyDown(e)
    } else {
      setIsFocus(true)
      setIsBlur(false)
      onFocus && onFocus(e)
    }
  }

  return (
    <div className="input--content">
      <input
        ref={ref}
        key={name}
        className={disabled ? 'disable' : ''}
        type={type}
        id={id}
        name={name}
        value={stateValue}
        onFocus={handleFocus}
        onBlur={(e) => {
          setIsFocus(false)
          setIsBlur(true)
          onBlur && onBlur(e)
        }}
        onKeyPress={(e) => {
          onKeyPress && onKeyPress(e)
        }}
        onKeyDown={(e) => {
          onKeyDown && onKeyDown(e)
        }}
        onChange={(e) => handleChange(e)}
        autoComplete="off"
        autoFocus={autoFocus}
        maxLength={maxLength}
        onClick={(e) => {
          onClick && onClick(e)
        }}
        placeholder={placeholder}
        style={sx}
      />
      {label && (
        <div className={isFocus ? 'input--label active' : (value + '').length > 0 && isBlur ? ' input--label filled' : 'input--label'}>
          {label}
        </div>
      )}
      {icon === 'pwd' && (
        <div className="icon" onClick={togglePwd}>
          {showIcon()}
        </div>
      )}
      {icon === 'chkcirle' && value.length > 0 && !isFocus && (
        <div className="icon --chkcirle">{<CheckCircle sx={{ color: '#14c508b0', fontSize: 26 }} />}</div>
      )}
      {icon === 'crossIcon' && stateValue && (
        <div className="cross--icon" onClick={resetItem} id={crossIconId}>
          <span className="cross">
            <FontAwesomeIcon icon={faXmark} color={'#777'} />
          </span>
        </div>
      )}
      {icon === 'chkActionGST' && value.length > 0 && (
        <div className="icon --chkBtn">
          {
            <span
              style={{ color: '#0086ff', textDecoration: 'underline', fontWeight: 'bold' }}
              onClick={() => {
                window.open(urls.searchTaxPayer)
              }}
            >
              Check
            </span>
          }
        </div>
      )}
      {icon === 'drop' && (
        <div className="icon--drop">
          <Dropdown />
        </div>
      )}
    </div>
  )
})

export default LineInputV3
